const OfferBanner = () => {
  const text = process.env.REACT_APP_OFFER_TEXT 
    return (
      <div className="flex justify-center mt-8 md:px-8 sm:px-4 px-2">
        <div className="inline-block px-8 py-4 text-white rounded-[16px] font-semibold text-lg relative animate-pulse-scale fontPoppins  "  style={{
              background: "linear-gradient(90deg, #CC0927 0%, #7E0105 100%)",
            }}>
          <span className="relative z-10 inline-block text-[18px] ">
            {text}
            <span className="ml-2.5 text-sm  font-normal text-white">
              Limited time only!
            </span>
          </span>
        </div>
      </div>
    );
  };
  
  
  export default OfferBanner;